(function($, undefined) {
	
	'use strict';
    var item;
    var itemClone;
    var itemsAndButtonsCtn;
    var itemsCtn;
    var addNewItemBtn;
    var saveItemsBtn;
    var deleteItemBtn;
    var saveItemsSuccessMsg;
    var chooseBtn;
    var closeChoicePopupBtn;
    var saveIconChoiceBtn;
    var deleteChoiceBtn;
    var howItWorksItem;
    var textCtnClone;

    var changeCloneAttrValue = function(t, attr, itemNumber) {
        var attrInitVal = t.attr(attr);
        var attrInitValSplit = attrInitVal.split('clone');
        var newAttrVal = attrInitValSplit[0] + itemNumber + attrInitValSplit[1];
        t.attr(attr, newAttrVal);
    };

    var addNewItem = function() {
        var t = $(this);
        var parent = t.closest(itemsAndButtonsCtn);
        var ctn = parent.find(itemsCtn);
        var itemCloneCopy = parent.find(itemClone).clone();
        var itemNumber = Math.floor(Math.random() * 100000);
        var localId = itemClone.data('local-id');
        
        ctn.append(itemCloneCopy);

        // change ids for labels
        itemCloneCopy.find('.item-text-to-modify').each(function() {
            changeCloneAttrValue($(this), 'ondblclick', itemNumber);
        });

        if (itemCloneCopy.find('.submit-icon-choice-btn').length !== 0) {       
            itemCloneCopy.find('.submit-icon-choice-btn').each(function() {
                changeCloneAttrValue($(this), 'data-label', itemNumber);
            });
        }

        itemCloneCopy.attr('data-id', itemNumber);
        itemCloneCopy.hide().removeClass('clone').slideDown(300);

        // listeners for new item
        $('.delete-item-btn').click(removeItem);
        $('.choose-btn').click(showPopup);
        $('.choice-popup .popup-inner-close').click(hideChoicePopup);
        $('.submit-icon-choice-btn').click(saveIconChoice);
    };

    var saveItemsList = function() {
        saveItemsSuccessMsg.slideUp(300);

        var t = $(this);
        var ctn = t.closest(itemsAndButtonsCtn);
        var contents = ctn.find(itemsCtn).find('.item-ctn');
        var idsList = '';
        var localId = contents.first().data('local-id');
        var label = 'items-list-' + localId;
        
        contents.each(function() {
            if($(this).data('id') !== ('' || undefined)){
                idsList += $(this).data('id') + "~!~";
            }
        });

        // save all custom ids list in a label
        updateLabel(label, idsList, 'fr', function() {
            updateLabel(label, idsList, 'en', function() {
                saveItemsSuccessMsg.slideDown(300);

                setTimeout(function() {
                    saveItemsSuccessMsg.slideUp(300);
                }, 5000);
            });
        });
    };

    var removeItem = function() {
        var t = $(this);

        t.closest('.item-ctn').slideUp(300);
        setTimeout(function() {
            t.closest('.item-ctn').remove();
        }, 300);
    };

    var showPopup = function() {
        var t = $(this);
        var type = t.attr('data-type');
        var parent = t.closest('.choice-popup-parent');
        var popup = $('.' + type + '-choice-popup');
        var relatedPopup = parent.find(popup);

        relatedPopup.fadeIn(300);
        $('.overlay').addClass('active');
    };

    var hideChoicePopup = function() {
        var t = $(this);
        var parentPopup = t.closest('.choice-popup');

        parentPopup.fadeOut(300);
        $('.overlay').removeClass('active');
    };

    var saveIconChoice = function() {
        var t = $(this);
        var parentPopup = t.closest('.icon-choice-popup');
        var iconChoiceInput = parentPopup.find('input:checked');

        if (iconChoiceInput.length !== 0) {
            $('.save-icon-error-msg').slideUp(300);

            var iconChoice = iconChoiceInput.val();
            var label = t.attr('data-label');

            // save choice in a label
            updateLabel(label, iconChoice, 'fr', function() {
                updateLabel(label, iconChoice, 'en', function() {
                    $('.save-icon-success-msg').slideDown(300);

                    setTimeout(function() {
                        $('.save-icon-success-msg').slideUp(300);

                        setTimeout(function() {
                            parentPopup.fadeOut(300);
                            $('.overlay').removeClass('active');
                        }, 600);
                    }, 3000);
                });
            });
        } else {
            $('.save-icon-error-msg').slideDown(300);

            setTimeout(function() {
                $('.save-icon-error-msg').slideUp(300);
            }, 5000);
        }
    };

    var deleteChoice = function() {
        var t = $(this);
        var label = t.attr('data-label');
        var parentCtn = t.closest('.delete-choice-ctn');
        var successMsg = parentCtn.find('.delete-choice-success-msg');

        updateLabel(label, '', 'fr', function() {
            updateLabel(label, '', 'en', function() {
                successMsg.slideDown(300);

                setTimeout(function() {
                    successMsg.slideUp(300);
                }, 3000);
            });
        });
    };

    var displayRelatedText = function() {
        var t = $(this);
        var parent = t.closest('.how-it-works-item-ctn');
        var id = parent.attr('data-id');
        var allItemsCtn = t.closest('.all-how-it-works-items-inner-ctn');
        var relatedTextCtnHeight = parent.find('.how-it-works-text-ctn').height();
        var relatedTextNode = parent.find('.how-it-works-text').clone();
        var currPosition = t.offset().top;
        var textCtnCloneCopy = textCtnClone.clone();

        textCtnCloneCopy.html(relatedTextNode).hide().addClass('displayed').attr('data-id', id);

        if (allItemsCtn.find('.text-only-clone.displayed').length === 0) {
            insertText(t, allItemsCtn, textCtnCloneCopy);
        } else if (allItemsCtn.find('.text-only-clone.displayed').length > 0 && allItemsCtn.find('.text-only-clone.displayed').attr('data-id') !== id) {
            var previousHeader = allItemsCtn.find('.how-it-works-header-ctn.open');
            var previousHeaderPosition = previousHeader.offset().top;
            var textCtn = allItemsCtn.find('.text-only-clone.displayed');

            previousHeader.removeClass('open');

            // if the new text can't be displayed in the current text container
            if (previousHeaderPosition !== currPosition) {            
                textCtn.removeAttr('style').slideUp(300);

                setTimeout(function() {
                    textCtn.remove();
                    insertText(t, allItemsCtn, textCtnCloneCopy);
                }, 300);
            } else {
                var previousText = textCtn.find('.how-it-works-text').fadeOut(300);
                relatedTextNode.hide();

                setTimeout(function() {
                    previousText.remove();
                    textCtn.css({'min-height': relatedTextCtnHeight, 'max-height': relatedTextCtnHeight});
                    textCtn.append(relatedTextNode).attr('data-id', id);
                    t.addClass('open');
                    
                    setTimeout(function() {
                        relatedTextNode.fadeIn(300);
                    }, 300);
                }, 300);
            }
        } else {
            animateTextClose(allItemsCtn, t);
        }
    };

    var insertText = function(t, allItemsCtn, textCtnCloneCopy) {
        $('.how-it-works-item-ctn', allItemsCtn).each(function() {
            if ($(this).offset().top > t.offset().top) {
                textCtnCloneCopy.insertBefore($(this));
                animateTextOpen(textCtnCloneCopy, t);
                return false;
            }
        });

        if (allItemsCtn.find('.text-only-clone.displayed').length === 0) {
            allItemsCtn.append(textCtnCloneCopy);
            animateTextOpen(textCtnCloneCopy, t);
        }
    };

    var animateTextOpen = function(textCtn, textHeader) {
        textCtn.slideDown(300);
        textHeader.addClass('open');

        setTimeout(function() {
            var height = textCtn.height();
            textCtn.css({'min-height': height, 'max-height': height});
        }, 500);
    };

    var animateTextClose = function(allItemsCtn, textHeader) {
        textHeader.removeClass('open');

        var textCtn = allItemsCtn.find('.text-only-clone.displayed');
        textCtn.removeAttr('style').slideUp(300);

        setTimeout(function() {
            textCtn.remove();
        }, 300);
    };

    var init = function () {
        item = $('.item-ctn');
        itemClone = $('.item-ctn.clone');
        itemsAndButtonsCtn = $('.items-and-buttons-ctn');
        itemsCtn = $('.all-items-ctn');
        addNewItemBtn = $('.add-new-item-btn');
        saveItemsBtn = $('.save-items-btn');
        deleteItemBtn = $('.delete-item-btn');
        saveItemsSuccessMsg = $('.save-items-success-msg');
        chooseBtn = $('.choose-btn');
        closeChoicePopupBtn = $('.choice-popup .popup-inner-close');
        saveIconChoiceBtn = $('.submit-icon-choice-btn');
        deleteChoiceBtn = $('.delete-choice-btn');
        howItWorksItem = $('.how-it-works-header-ctn');
        textCtnClone = $('.how-it-works-item-ctn.text-only-clone');

        addNewItemBtn.click(addNewItem);
        deleteItemBtn.click(removeItem);
        saveItemsBtn.click(saveItemsList);
        chooseBtn.click(showPopup);
        closeChoicePopupBtn.click(hideChoicePopup);
        saveIconChoiceBtn.click(saveIconChoice);
        deleteChoiceBtn.click(deleteChoice);
        howItWorksItem.click(displayRelatedText);

        $(window).resize(function() {
            $('.how-it-works').each(function() {
                if ($(this).find('.how-it-works-header-ctn.open').length > 0) {
                    animateTextClose($(this).find('.all-how-it-works-items-inner-ctn'), $(this).find('.how-it-works-header-ctn.open'));
                }
            });
        });
    };
    
    init();
	
})(jQuery);
